import React from "react";

const socialMedia = [
  {
    name: "intagram",
    href: "https://www.instagram.com/rajrdevelopment/?next=%2F",
    svg: `<svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[25px] h-[25px]"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      d="M8.62499 2.58337H17.375C20.7083 2.58337 23.4167 5.29171 23.4167 8.62504V17.375C23.4167 18.9774 22.7801 20.5141 21.6471 21.6471C20.5141 22.7802 18.9773 23.4167 17.375 23.4167H8.62499C5.29166 23.4167 2.58333 20.7084 2.58333 17.375V8.62504C2.58333 7.02269 3.21986 5.48597 4.35289 4.35294C5.48592 3.21991 7.02265 2.58337 8.62499 2.58337ZM8.41666 4.66671C7.4221 4.66671 6.46827 5.0618 5.76501 5.76506C5.06175 6.46832 4.66666 7.42215 4.66666 8.41671V17.5834C4.66666 19.6563 6.34374 21.3334 8.41666 21.3334H17.5833C18.5779 21.3334 19.5317 20.9383 20.235 20.235C20.9382 19.5318 21.3333 18.5779 21.3333 17.5834V8.41671C21.3333 6.34379 19.6562 4.66671 17.5833 4.66671H8.41666ZM18.4687 6.22921C18.8141 6.22921 19.1453 6.36639 19.3895 6.61058C19.6336 6.85477 19.7708 7.18596 19.7708 7.53129C19.7708 7.87662 19.6336 8.20781 19.3895 8.452C19.1453 8.69619 18.8141 8.83337 18.4687 8.83337C18.1234 8.83337 17.7922 8.69619 17.548 8.452C17.3038 8.20781 17.1667 7.87662 17.1667 7.53129C17.1667 7.18596 17.3038 6.85477 17.548 6.61058C17.7922 6.36639 18.1234 6.22921 18.4687 6.22921ZM13 7.79171C14.3813 7.79171 15.7061 8.34044 16.6828 9.31719C17.6596 10.2939 18.2083 11.6187 18.2083 13C18.2083 14.3814 17.6596 15.7061 16.6828 16.6829C15.7061 17.6596 14.3813 18.2084 13 18.2084C11.6187 18.2084 10.2939 17.6596 9.31715 16.6829C8.34039 15.7061 7.79166 14.3814 7.79166 13C7.79166 11.6187 8.34039 10.2939 9.31715 9.31719C10.2939 8.34044 11.6187 7.79171 13 7.79171ZM13 9.87504C12.1712 9.87504 11.3763 10.2043 10.7903 10.7903C10.2042 11.3764 9.87499 12.1712 9.87499 13C9.87499 13.8288 10.2042 14.6237 10.7903 15.2097C11.3763 15.7958 12.1712 16.125 13 16.125C13.8288 16.125 14.6237 15.7958 15.2097 15.2097C15.7958 14.6237 16.125 13.8288 16.125 13C16.125 12.1712 15.7958 11.3764 15.2097 10.7903C14.6237 10.2043 13.8288 9.87504 13 9.87504Z"
      fill="white"
    />
  </svg>`,
  },
  {
    name: "tiktok",
    href: "https://www.tiktok.com/@rashedaljabridevelopment?_t=8oKuXBgOeRe&_r=1",
    svg: `<svg
            width={26}
            height={26}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[25px] h-[25px]"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M17.7917 6.5625C17.0796 5.74961 16.6872 4.70566 16.6875 3.625H13.4687V16.5417C13.4439 17.2407 13.1488 17.9027 12.6456 18.3885C12.1423 18.8742 11.4703 19.1457 10.7708 19.1458C9.29166 19.1458 8.0625 17.9375 8.0625 16.4375C8.0625 14.6458 9.79166 13.3021 11.5729 13.8542V10.5625C7.97916 10.0833 4.83333 12.875 4.83333 16.4375C4.83333 19.9062 7.70833 22.375 10.7604 22.375C14.0312 22.375 16.6875 19.7188 16.6875 16.4375V9.88542C17.9927 10.8228 19.5597 11.3257 21.1667 11.3229V8.10417C21.1667 8.10417 19.2083 8.19792 17.7917 6.5625Z"
              fill="white"
            />
          </svg>`,
  },
  {
    name: "linkedin",
    href: "https://www.linkedin.com/company/rashed-al-jabri-real-estate-development/?viewAsMember=true",
    svg: `<svg
            width={26}
            height={26}
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-[25px] h-[25px]"
            preserveAspectRatio="xMidYMid meet"
          >
            <path
              d="M7.72917 5.70828C7.72889 6.26081 7.50913 6.79061 7.11824 7.18111C6.72734 7.57162 6.19733 7.79084 5.64479 7.79057C5.09226 7.79029 4.56246 7.57053 4.17196 7.17964C3.78145 6.78874 3.56222 6.25873 3.5625 5.70619C3.56278 5.15366 3.78253 4.62386 4.17343 4.23336C4.56433 3.84285 5.09434 3.62363 5.64688 3.6239C6.19941 3.62418 6.7292 3.84394 7.11971 4.23483C7.51021 4.62573 7.72944 5.15574 7.72917 5.70828ZM7.79167 9.33328H3.625V22.3749H7.79167V9.33328ZM14.375 9.33328H10.2292V22.3749H14.3333V15.5312C14.3333 11.7187 19.3021 11.3645 19.3021 15.5312V22.3749H23.4167V14.1145C23.4167 7.68744 16.0625 7.92703 14.3333 11.0833L14.375 9.33328Z"
              fill="white"
            />
          </svg>`,
  },
];

const Footer = () => {
  return (
    <div className="flex flex-col justify-center items-center overflow-hidden xl:px-28 sm:px-10 py-5 bg-black">
      <div className="flex-col justify-center items-center text-white">
        <div className="sm:flex block justify-center items-center sm:space-x-7 text-base text-center sm:space-y-0 space-y-1">
          <p className="whitespace-nowrap font-medium">
            <a href="/">Home</a>
          </p>
          <p className="whitespace-nowrap font-medium">
            <a href="/projects">Our Projects</a>
          </p>
          <p className="whitespace-nowrap font-medium">
            <a href="https://www.rashidaljabrigroup.com/contactus">
              Contact us
            </a>
          </p>
          <p className="whitespace-nowrap font-medium">
            <a
              href="https://in.frms.link/z4h0kzc/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Soft Launch
            </a>
          </p>
          <p className="whitespace-nowrap font-medium">
            <a
              href="https://www.rashidaljabrigroup.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              RSJ Group
            </a>
          </p>
        </div>
        <div className="flex justify-center items-center gap-10 py-5">
          {socialMedia.map((item, index) => (
            <a
              key={index}
              href={item.href}
              target="_blank"
              dangerouslySetInnerHTML={{ __html: item.svg }}
              className="w-[26px]"
            />
          ))}
        </div>
      </div>
      <p className="text-center text-xs text-white">
        © 2024 RASHED AL JABRI REAL ESTATE DEVELOPMENT | ALL RIGHTS RESERVED.
      </p>
    </div>
  );
};

export default Footer;
